import React from 'react';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';

/**
 * Intro text for the Fishery Management Adjustments left panel.
 * Registered as 'fish-mgmt-adjustments-text'.
 */
export default function FishMgmtAdjustmentsText(_props: RegistryComponentProps): React.ReactElement {
  return (
    <div>
      <p>
        Examine how various decisions in the science and management process impact the performance of the fishery system.
      </p>
      <br />
      <p>
        Select a Fishery in the top navigation bar to access adjustments. Re-run models to examine impacts across a range of performance indicators, shown in the box on the right.
      </p>
    </div>
  );
}
